<template>
  <div class="school_manage">
    <div class="query_wapper">
      <div class="query_item">
        <el-input
          v-model="query.keyword"
          clearable
          placeholder="关键词搜索"
          style="width:390px"
          @keyup.enter.native="handleSearch"
        >
          <el-button class="search_btn" slot="append" @click="handleSearch">查询</el-button>
        </el-input>
      </div>
      <div class="query_item">
        <el-button style="width:90px" type="primary" @click="exportExcel">导出</el-button>
      </div>
    </div>
    <el-table border style="width:100%;margin-top:20px" :data="tableData">
      <el-table-column label="序号" align="center" type="index" width="80"></el-table-column>
      <el-table-column label="协会名称" align="center" prop="name">

      </el-table-column>
      <el-table-column label="账号" align="center" prop="account"></el-table-column>
      <el-table-column label="密码" align="center" prop="pass">
        <template slot-scope="{row,column,$index}">
          <div
            style="display:flex;align-items:center;justify-content:center"
            @click.stop="{{changeNum($index,column,'editRemarkInput')}}"
          >
            <el-input
              v-if="editable[$index].pass"
              v-model="row.pass"
              size="mini"
              style="width:200px"
              @blur="$event=>handleBlur($event,$index,column)"
              class="editRemarkInput"
            ></el-input>
            <el-button
              @click="updateTable($index)"
              style="padding:12px 5px;"
              type="success"
              v-if="editable[$index].pass"
            >保存</el-button>
            <span v-else>{{row.pass}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="审核范围" align="center" prop="projectStr"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import { getSocietyList, updateSociety } from "@/api/management-function";
import { table, message, page } from "@/common/js/mixins.js";
import { baseUrl } from "@/utils/config";
export default {
  mixins: [table, message, page],
  data() {
    return {
      query: {
        keyword: ""
      },
      titles: ["name", "pass"],
      editable: [],
      btnLoading: false,
      saveItem: {} //表格修改列数据
    };
  },
  methods: {
    getCellIndex: function({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getMemberList();
    },
    // 表格修改
    updateTable(index) {
      let { id, name, pass } = this.saveItem;
      updateSociety({
        id,
        pass
      })
        .then(res => {
          this.openSuccess("修改成功！");
          this.getMemberList();
        })
        .catch(err => {});
    },
    // 表格输入框离开焦点
    handleBlur(e, index, col) {
      setTimeout(() => {
        this.editable[index][col.property] = false;
        this.saveItem = {};
      }, 200);
    },
    // 表格点击
    changeNum(index, row, className) {
      this.editable.filter(item => {
        for (let temp in item) item[temp] = false;
      });
      this.editable[index][row.property] = true;
      this.saveItem = this.tableData[index];
      //让input自动获取焦点
      this.$nextTick(function() {
        var editInputList = document.getElementsByClassName(className);
        editInputList[0].children[0].focus();
      });
    },
    // 导出
    exportExcel() {
      let params = [];
      for (let k in this.query) {
        if (this.query[k] === 0) {
          params.push(k + "=" + this.query[k]);
        } else {
          params.push(k + "=" + (this.query[k] ? this.query[k] : ""));
        }
      }
      window.location.href =
        baseUrl + "/member/downloadSocietyList?" + params.join("&");
    },
    // 数据列表
    getMemberList() {
      getSocietyList({
        ...this.query
      })
        .then(res => {
          this.tableData = res;
          res.filter(item => {
            let obj = {};
            this.titles.filter(temp => {
              obj[temp] = false;
            });
            this.editable.push(obj);
          });
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getMemberList();
  }
};
</script>
<style lang="less" scoped>
.school_manage {
  .excel_down {
    margin-left: 10px;
    font-size: 12px;
    color: rgb(22, 155, 213);
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>